function CheckmarkIcon() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-inherit">
            <path d="M3.99993 7.8L1.19993 5L0.266602 5.93334L3.99993 9.66667L11.9999 1.66667L11.0666 0.733337L3.99993 7.8Z" fill="#1C9690"/>
        </svg>
    )
}

export default CheckmarkIcon